enum ConciliationType {
  ERP_WITH_MANY_BANKS = 'ERP_WITH_MANY_BANKS',
  BANK_WITH_MANY_ERPS = 'BANK_WITH_MANY_ERPS',
  ERPS = 'ERPS',
}

export default ConciliationType;
